import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Color, ColorEnvironment, Font, Flexbox } from './Styles';

import Image from './Image';

const styles = StyleSheet.create({
  actionCard: {
    width: 220,
    '@media (min-height: 600px)': {
      height: 280,
    },
    borderRadius: '10px',
    border: `3px solid ${Color.primary}`,
    cursor: 'pointer',
    marginTop: 30,
    marginBottom: 20,
    paddingBottom: 20,
    boxShadow: '0px 0px 8px 6px rgba(0, 0, 0, 0.1)'
  },
  small: {
    height: 160,
    margin: 10
  },
  topImage: {
    position: 'relative',
    top: -43.3,
    width: 86.6,
    height: 86.6,
    borderRadius: '100%'
  },
  description: {
    textAlign: 'center',
    margin: 10
  },
  smallDescription: {
    marginTop: -20,
    fontSize: '90%'
  }
});

class ActionCard extends Component {
  render() {
    return(
      <div className={css(ColorEnvironment.normal, Flexbox.column, Flexbox.axisEnd, Flexbox.crossCenter, styles.actionCard, Font.body, this.props.small && styles.small)} onClick={this.handleSelectAction.bind(this)}>
        <Image extraStyles={[styles.topImage, ColorEnvironment.inverse]} filename={this.props.action.iconFilename} />
        <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.centeredItem, Flexbox.grow, Font.heading, styles.description, this.props.small && styles.smallDescription)}>
          <div className={css(Flexbox.centeredItem)}>
            {this.props.action.description}
          </div>
        </div>
      </div>
    );
  }

  handleSelectAction() {
    this.props.onSelect();
  }
}

export default ActionCard;



// WEBPACK FOOTER //
// ./src/ActionCard.js